import classNames from 'classnames';

import { isEnabled } from 'Config';

import SmartImage from 'Containers/SmartImage';

import type { BackgroundImageShape } from './types';

type Props = {
  className?: string;
  sources: BackgroundImageShape;
};

const BackgroundImage = ({ className, sources }: Props) => (
  <SmartImage
    transformWebp={isEnabled('webp')}
    className={classNames('StretchedBox Bgz(cv) Bgp(c) Pe(n)', className)}
    urls={[sources.s, sources.l]}
    intendedAspectRatio="natural"
  />
);

export default BackgroundImage;
